import ContentItem from "@/models/ContentItem";

export default <ContentItem[]>[
    {
        "title": "ASCII shrug",
        "content": "¯\\_(ツ)_/¯"
    },
    {
        "title": "Degree symbol",
        "content": "°"
    },
    {
        "title": "Copyright symbol",
        "content": "©"
    },
    {
        "title": "Lorem ipsum",
        "content": "Lorem ipsum dolor sit amet, has eu dolorem mediocrem, purto nostrud suscipiantur mea ne. Cu vis stet laoreet sapientem, lorem quidam inimicus eu qui. Ut eos aliquam percipitur, mel te noster legimus. Vim ei vivendo instructior. Velit graece noluisse cum et, pertinax partiendo facilisis ius ei, vitae tacimates nam at. Eu mundi ludus eum, ea has purto aliquam argumentum."
    },
    {
        "title": "Euro sign",
        "content": "€"
    },
    {
        "title": "Pound sign",
        "content": "£"
    },
    {
        "title": "Pi symbol",
        "content": "π"
    }
]


// WEBPACK FOOTER //
// ./src/data/default_data.ts